import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  margin: {
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: 20,
    },
  },
  btn2: {
    marginRight: 15,
  },
}));
